module.exports = __webpack_public_path__ + "img/img1-1.5c93e900.png";